module.exports = __webpack_public_path__ + "static/img/language_sel.f526e6a2.png";